export interface AppointmentStatusVisual {
  label: string;
  /** Pill background */
  bg: string;
  /** Pill / event text */
  text: string;
  /** Pill dot */
  dot: string;
  /** Calendar event card soft background + text */
  eventBg: string;
  eventText: string;
  /** Left accent stripe on calendar cards */
  accent: string;
  /** Legend swatch */
  swatch: string;
}

export const STATUS_VISUAL: Record<string, AppointmentStatusVisual> = {
  scheduled: {
    label: 'Scheduled',
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    dot: 'bg-amber-500',
    eventBg: 'bg-amber-100',
    eventText: 'text-amber-800',
    accent: 'bg-amber-500',
    swatch: 'bg-amber-500',
  },
  confirmed: {
    label: 'Confirmed',
    bg: 'bg-brand-100',
    text: 'text-brand-700',
    dot: 'bg-brand-500',
    eventBg: 'bg-brand-100',
    eventText: 'text-brand-800',
    accent: 'bg-brand-500',
    swatch: 'bg-brand-500',
  },
  checked_in: {
    label: 'Checked in',
    bg: 'bg-brand-100',
    text: 'text-brand-700',
    dot: 'bg-brand-500',
    eventBg: 'bg-brand-100',
    eventText: 'text-brand-800',
    accent: 'bg-brand-500',
    swatch: 'bg-brand-500',
  },
  in_progress: {
    label: 'In progress',
    bg: 'bg-coral-100',
    text: 'text-coral-600',
    dot: 'bg-coral-500',
    eventBg: 'bg-coral-100',
    eventText: 'text-coral-600',
    accent: 'bg-coral-500',
    swatch: 'bg-coral-500',
  },
  completed: {
    label: 'Completed',
    bg: 'bg-mint-100',
    text: 'text-mint-600',
    dot: 'bg-mint-500',
    eventBg: 'bg-mint-100',
    eventText: 'text-mint-600',
    accent: 'bg-mint-500',
    swatch: 'bg-mint-500',
  },
  cancelled: {
    label: 'Cancelled',
    bg: 'bg-coral-100',
    text: 'text-coral-700',
    dot: 'bg-coral-500',
    eventBg: 'bg-coral-100',
    eventText: 'text-coral-800',
    accent: 'bg-coral-500',
    swatch: 'bg-coral-500',
  },
  no_show: {
    label: 'No-show',
    bg: 'bg-coral-100',
    text: 'text-coral-700',
    dot: 'bg-coral-500',
    eventBg: 'bg-coral-100',
    eventText: 'text-coral-800',
    accent: 'bg-coral-500',
    swatch: 'bg-coral-500',
  },
};

export const STATUS_LEGEND_ORDER = [
  'scheduled',
  'confirmed',
  'checked_in',
  'in_progress',
  'completed',
  'cancelled',
  'no_show',
] as const;

export function getStatusVisual(status: string): AppointmentStatusVisual {
  return STATUS_VISUAL[status] ?? STATUS_VISUAL['scheduled']!;
}
